import React, {useEffect, useState} from 'react';
import {Line} from '@ant-design/plots';
import {useSelector} from 'react-redux';
import {Spin, Alert, Card, Button, Tooltip} from 'antd';
import {FileExcelFilled} from '@ant-design/icons';
import * as XLSX from 'xlsx';
import {useGetManagerReportQuery} from "../../../../../slices/rootApiSlices/reportApiSlice";

const TotalDistance = () => {

    const {user} = useSelector((state) => state.auth);
    const [chartData, setChartData] = useState([]);
    const {data: apiData, isLoading, error} = useGetManagerReportQuery(user?.token);

    useEffect(() => {
        if (apiData?.data) {
            const formattedData = apiData.data
                .map(item => ({
                    Tarih: new Date(item.result_date).toLocaleString(),
                    Mesafe: parseFloat(item.daily_increase_vehicle_distance),
                }))
                .filter(data => data.Mesafe !== 0);
            setChartData(formattedData);
        }
    }, [apiData]);

    const handleDownload = () => {
        const title = 'Toplam_Mesafe_Raporu';
        const workbook = XLSX.utils.book_new();

        // Excel verisi hazırlanıyor
        const worksheetData = [
            ['Rapor Tipi:', 'Toplam Mesafe Raporu'], // Başlık
            ['Rapor Oluşturma Tarihi:', new Date().toLocaleString()], // Tarih ve Saat
            ['Raporu Oluşturan:', user?.name || 'Bilinmiyor'], // Kullanıcı Bilgisi
            [], // Boş Satır
            ['Tarih', 'Mesafe [km]'], // Tablo Başlıkları
            ...chartData.map(data => [data.Tarih, data.Mesafe]) // Tarih ve Mesafe Verisi
        ];

        const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

        // Sütun genişliği ayarlanıyor
        const maxWidths = worksheetData[0].map((_, colIndex) =>
            Math.max(...worksheetData.map(row => (row[colIndex]?.toString().length || 0)))
        );
        worksheet['!cols'] = maxWidths.map(width => ({width}));

        XLSX.utils.book_append_sheet(workbook, worksheet, 'Toplam Mesafe Raporu');

        // Excel dosyasını kaydetme
        XLSX.writeFile(workbook, `${title}.xlsx`);
    };

    if (isLoading) {
        return <Spin style={{display: 'block', margin: 'auto', marginTop: '20%'}}/>;
    }

    if (error) {
        return <Alert message="Veri yüklenirken bir hata oluştu." type="error"/>;
    }

    const config = {
        data: chartData,
        padding: 'auto',
        xField: 'Tarih',
        yField: 'Mesafe',
        xAxis: {
            tickCount: 5,
        },
        slider: {
            start: 0.1,
            end: 0.5,
        },
    };

    return (
        <Card
            type="inner"
            size="small"
            style={{marginBottom: 10}}
            title="Toplam Mesafe"
            extra={
                <Tooltip title="Rapor olarak indir">
                    <Button
                        type="text"
                        icon={<FileExcelFilled/>}
                        onClick={handleDownload}
                    />
                </Tooltip>
            }
        >
            <Line {...config} style={{height: 355}}/>
        </Card>
    );
};

export default TotalDistance;
